import { render, staticRenderFns } from "./DiscountingComponent.vue?vue&type=template&id=2fe619b5&scoped=true"
import script from "./DiscountingComponent.vue?vue&type=script&lang=js"
export * from "./DiscountingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe619b5",
  null
  
)

export default component.exports